module.exports = __webpack_public_path__ + "static/media/userPlaceholder.6e30b34d.jpg";